import React from 'react';
import { CopyOutlined } from '@ant-design/icons';
import { message, Tooltip } from 'antd';

const CopyIconButton = ({ text, className = '' }) => {
  const handleCopy = async (e) => {
    e.stopPropagation();
    if (!text) return;
    try {
      await navigator.clipboard.writeText(String(text));
      message.success('کپی شد');
    } catch {
      message.error('خطا در کپی');
    }
  };

  return (
    <Tooltip title="کپی">
      <button
        type="button"
        onClick={handleCopy}
        className={`inline-flex items-center justify-center w-5 h-5 rounded text-gray-400 hover:text-blue-500 hover:bg-blue-50 dark:hover:bg-blue-900/20 transition-colors border-0 bg-transparent p-0 cursor-pointer ${className}`}
        aria-label="کپی"
      >
        <CopyOutlined style={{ fontSize: 12 }} />
      </button>
    </Tooltip>
  );
};

export default CopyIconButton;
